export default __webpack_public_path__ + "static/media/link-icon.2456e2f5.png";